import { ScreenFormatType } from '#enums/mediaTypes.ts';
import { FeaturePlayerMovieTabPanel } from './Movie/index.tsx';
import { FeaturePlayerTvTabPanel } from './Tv/index.tsx';

export type FeaturePlayerTabPanelProps = {
  episodeNumber?: number;
  id: string;
  seasonNumber?: number;
  title?: string;
  type: ScreenFormatType;
};

export const FeaturePlayerTabPanel = ({ episodeNumber, id, seasonNumber, title, type }: FeaturePlayerTabPanelProps) =>
  type === ScreenFormatType.Movie ? (
    <FeaturePlayerMovieTabPanel id={id} title={title} />
  ) : (
    // Based on when `title` is passed into component, the prop can
    // never be undefined at this point.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    <FeaturePlayerTvTabPanel initialPathIds={[id, seasonNumber, episodeNumber]} title={title!} />
  );
